var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "column" } },
    [
      _c(
        "div",
        {
          staticStyle: { display: "flex", "justify-content": "space-between" }
        },
        [
          _c("el-input", {
            staticStyle: { flex: "1" },
            attrs: { disabled: _vm.disabled },
            model: {
              value: _vm.cargoDoc.notifyCode,
              callback: function($$v) {
                _vm.$set(_vm.cargoDoc, "notifyCode", $$v)
              },
              expression: "cargoDoc.notifyCode"
            }
          }),
          _c("cargo-advance-select", {
            staticStyle: { flex: "1" },
            attrs: {
              disabled: _vm.disabled,
              "select-type": _vm.selectTypeNames.basic_data_Company,
              "method-params": { notify: true, active: true },
              filterable: "",
              "default-value": _vm.cargoDoc.notifyId || ""
            },
            on: { parentCallBack: _vm.notifyAutoCompleteChange }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "margin-top": "5px" } },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: _vm.disabled },
              on: { click: _vm.onClear }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")) + " ")]
          ),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "5px" },
              attrs: { type: "primary", disabled: _vm.disabled },
              on: {
                click: function($event) {
                  return _vm.onCopyConsignee(false)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.CopyTheConsignee")) + " ")]
          )
        ],
        1
      ),
      _vm._l(7, function(i) {
        return _c("cargo-input", {
          key: i,
          staticStyle: { "margin-top": "5px" },
          attrs: {
            "use-read-only": true,
            disabled: _vm.disabled,
            "auto-uppercase": _vm.autoUppercase,
            "filter-chars": false
          },
          on: {
            change: function($event) {
              return _vm.onChange("notifyLine" + i)
            }
          },
          model: {
            value: _vm.cargoDoc["notifyLine" + i],
            callback: function($$v) {
              _vm.$set(_vm.cargoDoc, "notifyLine" + i, $$v)
            },
            expression: "cargoDoc['notifyLine'+i]"
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }